'use strict';

var _ = require('lodash');
var DashboardPanelTransformerFactory = function DashboardPanelTransformerFactory(DataTransformer) {
  function DashboardPanelTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'fim-dashboard';
    this.targetType = 'dashboard-alerts-panel';
    this.priority = 0;
  }
  DashboardPanelTransformer.prototype = Object.create(DataTransformer.prototype);
  DashboardPanelTransformer.constructor = DashboardPanelTransformer;
  DashboardPanelTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  DashboardPanelTransformer.prototype.isCacheable = function () {
    return true;
  };
  DashboardPanelTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + metrics.join('-');
  };
  DashboardPanelTransformer.prototype.transform = function (data) {
    var responseResults = _.get(data, 'domain.results', []);
    for (var i = 0; i < responseResults.length; i++) {
      var item = responseResults[i];
      item.month = item.month - 1;
      item.market = item.origin + '-' + item.destination;
    }
    return responseResults;
  };
  return DashboardPanelTransformer;
};
DashboardPanelTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = DashboardPanelTransformerFactory;